export const SUBMENU_REGISTRY = {
  BASIC: () => import('./BasicSubMenu.vue'),
  PROJECT: () => import('./ProjectSubMenu.vue'),
}
